import { render, staticRenderFns } from "./Installing.vue?vue&type=template&id=5932f001"
import script from "./Installing.vue?vue&type=script&lang=ts"
export * from "./Installing.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports